"use client";
import { useMutation } from "@tanstack/react-query";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { postApiPracticesPracticeIdPatientsPatientIdCaptureSessions } from "@/lib/api-client/endpoints/capture-sessions/capture-sessions";
import type { CaptureSessionResponse } from "lib/api-types/schemas";

export function useCaptureSession() {
  const { tenantId } = useTenantRouteContext();

  return useMutation<CaptureSessionResponse, Error, string>({
    mutationFn: (patientId: string) =>
      postApiPracticesPracticeIdPatientsPatientIdCaptureSessions(
        tenantId,
        patientId,
        {
          channel: "staff",
          consentAccepted: true,
        },
      ).then((res) => res.data),
  });
}
